import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';

export class PriceListItem extends ModelBase {
  fromDate: LocalDate;
  amountPerUnit: Money;
}
